export class FetchError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'FetchError';
    Object.setPrototypeOf(this, new.target.prototype);
  }
}

export async function statusText(response: Response): Promise<string> {
  if (response.statusText !== '') {
    return Promise.resolve(response.statusText);
  }

  return response.text();
}
